import React, { useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
// import { MockUpUtil } from '@xengage/gw-portals-util-js';
// import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { UWIssuesUtil } from "premier-policycommon-util-js";
import { useTranslator } from '@jutro/locale';
import PrintDocumentsComponent from "premier-capability-policyjob-react/components/PrintDocumentsComponent/PrintDocumentsComponent";
import FormsComponent from "premier-capability-policyjob-react/components/FormComponent/FormComponent";
import QuoteValidityComponent from "premier-capability-policyjob-react/components/QuoteValidityComponent/QuoteValidityComponent";
import QuoteDetailsComponent from 'premier-capability-policyjob-react/components/QuoteDetailsComponent/QuoteDetailsComponent';
import styles from './QuotePage.module.scss';
import VehicleCoverage from '../../components/VehicleCoverage/VehicleCoverage';
// import setErrorModalFromWhitelist from '../../config/WhitelistedErrors';
import presentationMetadata from './QuotePage.metadata.json5';
import messages from './QuotePage.messages';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function QuotePage(props) {
    const { authHeader } = useAuthentication();
    const {
        wizardData: submissionVM,
        steps,
        jumpTo,
        currentStep,
        // updateWizardData,
        underwritingIssues
    } = props;

    // const { showAlert } = useModal();
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    // const { LoadSaveService } = useDependencies('LoadSaveService');
    const { pageKey } = currentStep;
    const isQuoteBlocked = UWIssuesUtil.isQuoteBlocked(underwritingIssues);
    const findBlockingPoint = UWIssuesUtil.findBlockingPoint(underwritingIssues);
    const underWritingIssuesNonBlocking = UWIssuesUtil.UWIssuesNonBlocking(underwritingIssues);
    // eslint-disable-next-line security/detect-object-injection
    const metadata = presentationMetadata[pageKey];

    const handleNext = useCallback(
        () => {
            const offeredQuotes = _.get(submissionVM.value, 'quoteData.offeredQuotes[0].publicID');

            _.set(submissionVM, 'bindData.chosenQuote', offeredQuotes);

            return submissionVM;
        },
        [submissionVM]
    );

    const navigateToCoverages = useCallback(
        () => {
            const indexOfGeneralCoverages = _.findIndex(
                steps,
                ({ path }) => path === '/vehicles'
            );

            jumpTo(indexOfGeneralCoverages);
        },
        [jumpTo, steps]
    );

    const getLimitValue = (terms, type) => {
        if (!_.isEmpty(terms) && terms[0].name === type) {
            return terms[0].chosenTermValue;
        }

        return '-';
    };


    const getDeductableValue = (terms, type) => {
        if (!_.isEmpty(terms) && terms.length > 1 && terms[1]?.name === type) {
            return terms[1].chosenTermValue;
        }

        return '-';
    };

    const getEmergencyRoadsideServiceLimitValue = (terms) => {
        if (!_.isEmpty(terms)) {
            return `${terms[0]?.chosenTermValue}/${terms[1]?.chosenTermValue} AGG`;
        }

        return '-';
    };

    const getCoverage = (coverages, isLineCoverage) => coverages.map((coverage) => ({
        name: coverage.name,
        coverageType: isLineCoverage ? "Policy" : null,
        limit: coverage.publicID === "PRVEmeRoadServCov" ?
            getEmergencyRoadsideServiceLimitValue(coverage.terms)
            : getLimitValue(coverage.terms, 'Limit'),
        deductible: getDeductableValue(coverage.terms, 'Deductible'),
        premium: coverage.premium
    }));


    const generateVehicleOverrides = () => {

        const overrides = submissionVM.value.lobData.recVehLine.coverables.vehLocRisks.map((vehicleDTO, index) => {
            const vehicleCoverage = getCoverage(vehicleDTO.clausesGroups.coverages);
            const vehicleEndorsement = getCoverage(vehicleDTO.clausesGroups.endorsementCoverages);

            return {
                [`vehicleCoverageInfo${index}`]: {
                    data: _.concat(vehicleCoverage),
                    show: true
                },
                [`endoCovAccordionCard${index}`]: {
                    show: false
                },
                [`vehicleEndoInfo${index}`]: {
                    data: _.concat(vehicleEndorsement),
                    show: false
                },
                [`vehicleSection${index}`]: {
                    title: submissionVM.value.lobData.recVehLine.coverables.vehLocRisks.length > 0 ? `Vehicle ${index + 1}` : ''
                },
                [`totalPremium`]: {
                    value: {
                        amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium?.totalBeforeTaxes?.amount
                    }
                },
                [`taxes`]: {
                    visible: _.get(submissionVM.value, 'baseData.baseState_Ext') === 'QC',
                    value: {
                        amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium?.taxes?.amount
                    }
                },
                [`fees`]: {
                    visible: submissionVM.value.quoteData?.offeredQuotes[0]?.premium.fees?.amount !== 0,
                    value: {
                        amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium.fees?.amount
                    }
                },
                [`totalCost`]: {
                    value: {
                        amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium?.total?.amount
                    }
                },
                [`inspectionFee`]: {
                    visible: submissionVM.value.baseData?.inspectionFee_Ext &&
                        submissionVM.value.baseData?.inspectionFee_Ext?.amount !== 0
                },
                [`extensionFee`]: {
                    visible: submissionVM.value.baseData?.extensionFee_Ext &&
                        submissionVM.value.baseData?.extensionFee_Ext?.amount !== 0
                },
                [`policyQuoteValDaysHead`]: {
                    content: translator(messages.rvQuoteValidityDays, {
                        quoteValidityDays: _.get(submissionVM, `baseData.quoteValidityDays_Ext.value`)
                    })
                },
                [`vehicleYear${index}`]: {
                    value: vehicleDTO.offering_Ext === 'MotCyc' ? vehicleDTO.year : vehicleDTO.yearBuilt,
                },
                [`vehicleEngineSize${index}`]: {
                    visible: vehicleDTO.offering_Ext === 'MotCyc',
                },
                [`vehicleMake${index}`]: {
                    value: vehicleDTO.offering_Ext === 'MotCyc' ? vehicleDTO.make : vehicleDTO.manufacturer,
                    label: vehicleDTO.offering_Ext === 'MotCyc' ? translator(messages.rvMake) : translator(messages.rvManufacturer)
                },               
                          
                // [`showContentToggleLink${index}`]: {
                //     onClick: () => toggleShowHide(index),
                //     icon: _.includes(openItems, index) ? 'mi-arrow-drop-up' : 'mi-arrow-drop-down',
                //     content: _.includes(openItems, index)
                //         ? nnslator(messages.hideVehicleCoverages)
                //         : translator(messages.showVehicleCoverages)
                // },
                // [`vehicleCoverageContainer${index}`]: {
                //     visible: _.includes(openItems, index)
                // }
            };
        });

        return Object.assign({}, ...overrides);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        underWritingIssues: {
            // eslint-disable-next-line object-shorthand
            underwritingIssues: underWritingIssuesNonBlocking,
            blockQuote: findBlockingPoint,
            filterUWIssuesInCustomOffering: false,
            quoteID: _.get(submissionVM.value, 'quoteID'),
            accountNumber: _.get(submissionVM.value, 'baseData.accountNumber')
        },
        quoteDetailsComponent: {
            wizardData: submissionVM
        },
        quoteValidityComponent: {
            wizardData: submissionVM
        },
        policyQuoteValidityDays: {
            content: _.get(submissionVM, `baseData.quoteValidityDays_Ext.value`)
        },
        PrintDocumentsComponent: {
            visible: submissionVM.value.baseData.periodStatus === 'Quoted',
            jobNumber: submissionVM.value.quoteID,
            authHeader
        },
        FormsComponent: {
            forms: submissionVM.value.lobData.recVehLine.lineCoverages.forms_Ext
        },
        ...generateVehicleOverrides()
    };

    useEffect(() => {
        // const quote = async () => {
        //     try {
        //         submissionVM.value = await LoadSaveService
        //             .saveAndQuoteSubmission(submissionVM.value, authHeader);
        //         submissionVM.value = MockUpUtil.setMockData(submissionVM.value, 'quote.PremierRV', 'bindData.contactPhone');
        //         updateWizardData(submissionVM);
        //     } catch (error) {
        //         setErrorModalFromWhitelist(error, showAlert);
        //     }
        // };

        // quote();
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            navigateToCoverages
        },
        resolveComponentMap: {
            vehiclecoverage: VehicleCoverage,
            quoteDetailsComponent: QuoteDetailsComponent,
            quoteValidityComponent: QuoteValidityComponent,
            PrintDocumentsComponent,
            FormsComponent
        }
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, submissionVM, id, path, overrideProps),
        [metadata.content, overrideProps, submissionVM]
    );

    return (
        <WizardPage
            disableNext={underWritingIssuesNonBlocking?.length > 0}
            onNext={handleNext}
        >
            <ViewModelForm
                uiProps={metadata.content}
                model={submissionVM}
                // resolveValue={readValue}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

QuotePage.propTypes = wizardProps;
export default QuotePage;